import { InsightsAiMetricResult } from '@percent/partner-dashboard/services/insightsAi/insightsAiService.types'

/**
 * The worked example from the insights-ai spec: two scalar metric results (a money
 * total and a plain count), each with a prior-quarter trend, plus the already
 * token-substituted prose. Used to fabricate a canned turn for the local-dev / test
 * chat (see `mockInsightsChatFetch`), so the box renders real-looking data without
 * a backend.
 */
export const MOCK_INSIGHTS_AI_MESSAGE =
  'Last quarter you raised GBP 12500.00 (+25.0% vs the prior quarter) from 480 donors (+20.0%).'

export const MOCK_INSIGHTS_AI_METRICS: InsightsAiMetricResult[] = [
  {
    ref: 'total_raised',
    title: 'Total raised (last quarter)',
    subtitle: 'Across all campaigns',
    metricData: {
      type: 'scalar',
      value: { type: 'money', amount: 1250000, currency: 'GBP' },
      trend: {
        value: { type: 'money', amount: 1000000, currency: 'GBP' },
        difference: { type: 'money', amount: 250000, currency: 'GBP' },
        percentage: 0.25,
        period: { from: '2026-01-01T00:00:00.000Z', to: '2026-04-01T00:00:00.000Z' }
      }
    }
  },
  {
    ref: 'donor_count',
    title: 'Unique donors (last quarter)',
    metricData: {
      type: 'scalar',
      value: 480,
      trend: {
        value: 400,
        difference: 80,
        percentage: 0.2,
        period: { from: '2026-01-01T00:00:00.000Z', to: '2026-04-01T00:00:00.000Z' }
      }
    }
  }
]
